// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"4da6ea2f","105":"1a62b9f1","240":"067dcb50","252":"cca4c5be","298":"2a9a2c57","354":"4c3642a4","362":"8e121de1","453":"8cd40781","526":"1776f533","708":"b1e3249b","787":"c8fd0327","791":"bd34eeb0","794":"33aa428f","828":"656cf7c2","961":"3d997737"}[chunkId] + ".chunk.js";
};